import "./risk-methodology-builder.scss";

import classnames from "classnames";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";

import { IconButton } from "@/components/Elements";
import { ConfirmationPopup } from "@/modules/shared/confirmation-popup/ConfirmationPopup";

import { RISK_RATING_COLORS } from "../../../config";
import { ResidualRisk } from "../../../types/risk-methodology";
import ColorSelect from "./ColorSelect";

interface RiskRatingRowProps extends ResidualRisk {
  index: number;
  updateText: (index: number, value: string) => void;
  updateColor: (index: number, value: string) => void;
  removeResidualRisk?: (index: number) => void;
  dataTestID?: string;
  hasError: boolean;
}

function RiskRatingRow({
  index,
  text,
  color,
  updateText,
  dataTestID,
  removeResidualRisk,
  updateColor,
  hasError,
}: RiskRatingRowProps) {
  const [clonedName, setClonedName] = useState(text);

  useEffect(() => {
    if (text !== clonedName) {
      setClonedName(text);
    }
  }, [text]);

  return (
    <div className="risk-methodology-builder__content__risk-rating-input-area">
      <span className="tw-contents">
        <textarea
          className={classnames(
            "risk-methodology-builder__content__risk-rating-name",
            { "ra-risk-rating-error": hasError },
          )}
          onChange={(e) => setClonedName(e.target.value)}
          onBlur={(e) => updateText(index, e.target.value)}
          value={clonedName}
          data-testid={`${dataTestID}-row-${index}-name`}
        />
        <ColorSelect
          index={index}
          selectedColor={color}
          updateColor={updateColor}
          availableColors={RISK_RATING_COLORS}
        />
      </span>
      <span className="tw-w-1/4">
        <span className="tw-float-right tw-block">
          <ConfirmationPopup
            text="Are you sure you want to delete this residual risk rating?"
            onConfirm={() => removeResidualRisk?.(index)}
            trigger={
              <IconButton
                icon="trash"
                data-testid={`${dataTestID}-row-${index}-remove`}
              />
            }
            disabled={!removeResidualRisk}
          />
        </span>
      </span>
    </div>
  );
}

export default observer(RiskRatingRow);
